// ======================================================================
// FILE:
// src/modules/wms/reports/pages/OpenWorkRegisterPage.jsx
//
// MODULE:
// Work Management System (WMS)
//
// FEATURE:
// Open Work Register
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import reportService
from "../services/reportService";

import ReportFilter
from "../components/ReportFilter";

import SummaryCards
from "../components/SummaryCards";

import ReportTable
from "../components/ReportTable";

import ExportMenu
from "../components/ExportMenu";

export default function OpenWorkRegisterPage() {

  const navigate =
    useNavigate();

  // ==========================================================
  // STATE
  // ==========================================================

  const [loading,
    setLoading] =
    useState(false);

  const [rows,
    setRows] =
    useState([]);

  const [summary,
    setSummary] =
    useState({});

  const [pagination,
    setPagination] =
    useState({

        page: 1,

        per_page: 25,

        total: 0,

        pages: 0,

        has_next: false,

        has_prev: false,

    });

  const [draftFilters, setDraftFilters] = useState({

    search: "",

    from_date: "",

    to_date: "",

    team_id: "",

    owner_id: "",

    executor_id: "",

    approver_id: "",

    priority: "",

    status: "",

    template_id: "",

    is_recurring: "",
    
    sort_by: "planned_due_date",

    sort_order: "asc",

    page: 1,

    per_page: 25,

});

const [filters, setFilters] = useState({

    search: "",

    from_date: "",

    to_date: "",

    team_id: "",

    owner_id: "",

    executor_id: "",

    approver_id: "",

    priority: "",

    status: "",

    template_id: "",

    is_recurring: "",
    sort_by: "planned_due_date",

    sort_order: "asc",

    page: 1,

    per_page: 25,

});


  // ==========================================================
  // LOAD
  // ==========================================================

  useEffect(() => {

    loadData();

  }, [filters]);

  // ==========================================================
  // LOAD DATA
  // ==========================================================

  async function loadData() {

    try {

      setLoading(true);

      const res =
        await reportService
          .getOpenWorkRegister(
            filters
          );

      setRows(
        res.rows || []
      );

      setSummary(
        res.summary || {}
      );

      setPagination(

    res.pagination || {

        page: 1,

        per_page: 25,

        total: 0,

        pages: 0,

        has_next: false,

        has_prev: false,

    }

);

    }

    catch (err) {

      console.error(err);

      alert(
        "Unable to load report."
      );

    }

    finally {

      setLoading(false);

    }

  }

  // ==========================================================
  // FILTER CHANGE
  // ==========================================================

  function handleFilterChange(
    name,
    value
) {

    setDraftFilters({

        ...draftFilters,

        [name]: value,

    });

}
function handleSearch() {

    setFilters({

        ...draftFilters,

        page: 1,

    });

}
function handleReset() {

    const emptyFilters = {

        search: "",

        from_date: "",

        to_date: "",

        team_id: "",

        owner_id: "",

        executor_id: "",

        approver_id: "",

        priority: "",

        status: "",

        template_id: "",

        is_recurring: "",

        page: 1,

        per_page: 25,

    };

    setDraftFilters(emptyFilters);

    setFilters(emptyFilters);

}

// ==========================================================
// SORT
// ==========================================================

function handleSort(column) {

    let order = "asc";

    if (

        filters.sort_by === column &&

        filters.sort_order === "asc"

    ) {

        order = "desc";

    }

    setFilters({

        ...filters,

        sort_by: column,

        sort_order: order,

        page: 1,

    });

}
  // ==========================================================
  // OPEN WORK
  // ==========================================================

  function openWork(row) {

    navigate(

      `/wms/work/${row.work_id}`

    );

  }

  // ==========================================================
  // RENDER
  // ==========================================================

  return (

    <div>

      {/* =================================================== */}
      {/* HEADER */}
      {/* =================================================== */}

      <div
        style={{

          display: "flex",

          justifyContent:
            "space-between",

          alignItems:
            "center",

          marginBottom: 20,

        }}
      >

        <div>

          <h2
            style={{
              margin: 0
            }}
          >
            Open Work Register
          </h2>

          <div
            style={{
              color: "#6c757d"
            }}
          >
            Operational Report
          </div>

        </div>

        <ExportMenu

          filters={filters}

        />

      </div>

      {/* =================================================== */}
      {/* SUMMARY */}
      {/* =================================================== */}

      <SummaryCards

        summary={summary}

      />

      {/* =================================================== */}
      {/* FILTERS */}
      {/* =================================================== */}

      <ReportFilter

    filters={draftFilters}

    onChange={handleFilterChange}

    onSearch={handleSearch}

    onReset={handleReset}

/>

      {/* =================================================== */}
      {/* TABLE */}
      {/* =================================================== */}

      <ReportTable

        loading={loading}

        rows={rows}

        pagination={pagination}

        filters={filters}

        setFilters={setFilters}
        onSort={handleSort}

        onRowClick={
          openWork
        }

      />

    </div>

  );

}